<template>
  <el-select v-model="value" placeholder="请选择" @change="changeValue($event)" :disabled="isDisabled">
    <el-option
      v-for="item in unitData"
      :key="item.code"
      :label="item.name"
      :value="item.code"
    />
  </el-select>
</template>
<script>
export default {
  props: {
    isDisabled: false
  },
  data() {
    return {
      value: '',
      unitData: [],
      dictType: {
        types: 'queryUnitCode'
      }
    }
  },
  methods: {
    changeValue(e) {
      this.$emit('queryUnitCode', this.value)
    },
    setSelectValue(value) {
      this.value = value
    },
    initDict(dictData) {
      this.unitData = dictData
    }
  }
}
</script>
